<template src="./InputTextNormal.html"></template>

<script>
export default {
  name: 'InputTextNormal',
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: () => false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: () => false
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: () => ''
    },
    valueDefault: {
      type: String,
      required: false,
      default: () => ''
    },
    placeholder: {
      type: String,
      required: false,
      default: () => ''
    },
    errorText: {
      type: String,
      required: false,
      default: () => ''
    },
    isError: {
      type: Boolean,
      required: false,
      default: () => false
    },
    required: {
      type: Boolean,
      required: false,
      default: () => false
    },
  },
  created() {
    if (this.valueDefault) {
      this.value = this.valueDefault
    }
  },
  data() {
    return {
      value: '',
      distanceWithLabel: '0px',
    }
  },
  watch: {
    value() {
      this.$emit('inputValue', this.value)
    },
    valueDefault() {
      this.value = this.valueDefault
    },
    errorText() {
      this.distanceWithLabel = (this.$refs.labelForm?.offsetWidth || 0) + 10 + 'px'
    }
  },
  methods: {
    onBlur() {
      this.value = this.value.trim();
      if (this.required) {
        this.$emit('blur', this.value)
      }
    }
  }
}
</script>

<style lang="scss">
  .input-number {
    position: relative;
  }
  .error-text {
    top: -5px;
    padding: .5rem .5rem;
    font-size: .76rem;
    color: #3a3a3a;
    background: #fff;
    border: 1px solid red;
    text-align: center;
    width: unset !important;
    position: absolute;
    z-index: 4;
    margin-top: -.5rem;
    line-height: 1.5;
    box-shadow: 0 1px 15px rgba(0, 0, 0, .04), 0 1px 6px rgba(0, 0, 0, .04);
    border-radius: 10px;
    &:before {
      content: "";
      position: absolute;
      left: -5px;
      right: initial;
      margin-left: 0;
      bottom: initial;
      top: 12px;
      width: 5px;
      border-top: 5px solid transparent;
      border-right: 5px solid red;
      border-bottom: 5px solid transparent;
    }
    &:after {
      content: "";
      position: absolute;
      left: -4px;
      right: initial;
      margin-left: 0;
      border-top: 5px solid transparent;
      border-right: 5px solid #fff;
      border-bottom: 5px solid transparent;
      bottom: initial;
      top: 12px;
      width: 5px;
    }
  }
  .is-error {
    border: 1px solid red;
  }
  .required {
    color: red;
  }
</style>
